import { render, staticRenderFns } from "./Hovertext.vue?vue&type=template&id=3bfa6c8f&scoped=true&"
import script from "./Hovertext.vue?vue&type=script&lang=js&"
export * from "./Hovertext.vue?vue&type=script&lang=js&"
import style0 from "./Hovertext.vue?vue&type=style&index=0&id=3bfa6c8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfa6c8f",
  null
  
)

export default component.exports